import apiClient from './apiService';

class SectionService {
    constructor() {
        if (SectionService.instance) {
            return SectionService.instance;
        }
        SectionService.instance = this;
    }

    async getAll() {
        try {
            const response = await apiClient.get('/section');
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    static getInstance() {
        if (!SectionService.instance) {
            SectionService.instance = new SectionService();
        }
        return SectionService.instance;
    }
}

export default SectionService.getInstance();
